export default "__VITE_ASSET__Bm10TexA__"